// extracted by mini-css-extract-plugin
export var button = "_ix-2";
export var card = "_ix-0";
export var closeButtonContainer = "_ix-3";
export var iconContainer = "_ix-1";